var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint0_linear_772_2327)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8425 14.4764L22.3975 14.4775H22.8425V23.5C22.8425 23.5072 22.8424 23.5144 22.8422 23.5215C22.8422 23.5218 22.8422 23.5222 22.8422 23.5225C22.8306 23.9259 22.5084 24.2481 22.105 24.2597C22.0975 24.2599 22.09 24.26 22.0825 24.26H15.76C15.3462 24.26 15.0121 23.9334 15.0003 23.5225C15.0001 23.5151 15 23.5076 15 23.5V17.1325V16.6646L22.8425 14.4764Z",
    stroke: "#000000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_772_2327",
    x1: 28.3208,
    y1: -4.32414,
    x2: -4.7806,
    y2: 14.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FDDF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceCardIcon);
export default __webpack_public_path__ + "static/media/PerformanceCardIcon.4efd5de28de8c6a4e09f83796a2c92ea.svg";
export { ForwardRef as ReactComponent };